import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import deliveryModesService from '../../services/delivery-modes';

import FormField from './FormField';
import { FormControlLabel, RadioGroup, FormControl, Radio } from '@mui/material';

class SetDeliveryModeContext extends React.Component {

  render () {
    const { classes, data, onChange } = this.props;

    return (
      <FormField>
        <FormControl className={classes.form_control}>
          <RadioGroup
            row
            name="delivery-context"
            id="delivery-context"
            value={data?.context || ''}
            onChange={ (e) => onChange({...data, ...{context: e.target.value}}) }
          >
            <FormControlLabel value={deliveryModesService.CONTEXT_BTOB} control={<Radio />} label="Commandes d'abonnés professionnels" />
            <FormControlLabel value={deliveryModesService.CONTEXT_BTOC} control={<Radio />} label="Commandes d'abonnés particuliers" />
          </RadioGroup>
        </FormControl>
      </FormField>
    )
  }
}

const styles = theme => ({
  form_control: {
    width: '100%',
  },
});

SetDeliveryModeContext.propTypes = {
  onChange: PropTypes.func.isRequired,
  data: PropTypes.object,
};

SetDeliveryModeContext.defaultProps = {
  data: {}
};

export default withStyles(styles, { withTheme: true })(SetDeliveryModeContext);
